define.alias("shared/components/shared/post/media/side-library", "settings/components/shared/post/media/side-library");